import { useEffect, useState } from 'react';
import { Paper, SearchInput } from '../../components/modules/ui/index';
import PlanRestrictedButton from '../../components/modules/ui/PlanRestrictedButton';
import TooltipIcons from './TooltipIcons';

// MUI icons
import StarIcon from '@mui/icons-material/StarOutlineOutlined';
import StarFullIcon from '@mui/icons-material/StarOutlined';

// data & hooks
import { arrayIcons } from './reporteIcon';
import { useContentTypeReportes } from './useReportes.hook';

const NavBar = ({ setShowModal }) => {
  const styleImage = 'cursor-pointer w-8 h-8';
  const setTypeContent = useContentTypeReportes(state => state.setTypeContent);
  const addFavoriteIcon = useContentTypeReportes(state => state.addFavoriteIcon);
  const removeFavoriteIcon = useContentTypeReportes(state => state.removeFavoriteIcon);
  const clickedIcons = useContentTypeReportes(state => state.clickedIcons);
  const resetTypeContent = useContentTypeReportes(state => state.resetTypeContent);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    resetTypeContent();
  }, [resetTypeContent]);

  const handleIconClick = (icon) => {
    setTypeContent(icon.id);
    setShowModal(true);
  };

  const handleStarClick = (e, icon) => {
    e.stopPropagation();
    if (clickedIcons.has(icon.id)) {
      removeFavoriteIcon(icon.id);
    } else {
      addFavoriteIcon(icon);
    }
  };

  const filteredIcons = searchTerm
    ? arrayIcons.filter(icon =>
        icon.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : arrayIcons;
  return (
    <Paper>
      <section className="flex items-center justify-end p-4">
        <SearchInput
          placeholder="Buscar reporte"
          classNameBorder="rounded-full"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </section>

      <section className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-6 py-4 max-w-screen-lg mx-auto place-items-center font-sans text-text">
        {filteredIcons.length > 0 ? (
          filteredIcons.map(icon => (
            <PlanRestrictedButton
              key={icon.id}
              reportId={icon.id}
              message={`El reporte "${icon.title}"`}
              className="w-full max-w-[220px]"
              onClick={() => handleIconClick(icon)}
            >
              <div className="relative flex flex-col items-center justify-start shadow-md border rounded-2xl w-full aspect-square p-3 cursor-pointer font-sans">
                {/* Tooltip */}
                {icon.tooltip && (
                  <div className="absolute top-2 right-2">
                    <TooltipIcons tooltipText={icon.tooltip} />
                  </div>
                )}

                {/* Favorite star */}
                <div className="absolute top-2 left-2">
                  {clickedIcons.has(icon.id) ? (
                    <StarFullIcon
                      className={styleImage}
                      style={{ color: 'orange' }}
                      onClick={e => handleStarClick(e, icon)}
                    />
                  ) : (
                    <StarIcon
                      className={styleImage}
                      style={{ color: '#a1a1aa' }}
                      onClick={e => handleStarClick(e, icon)}
                    />
                  )}
                </div>

                {/* Icon */}
                <div className="mt-5 text-primary text-[64px]">
                  {icon.icon}
                </div>

                {/* Title */}
                <p className="text-center text-[11px] sm:text-[12px] md:text-[13px] mt-3 font-semibold text-text leading-snug">
                  {icon.title}
                </p>
              </div>
            </PlanRestrictedButton>
          ))
        ) : (
          searchTerm && (
            <p className="text-center text-sm text-muted font-sans">No se encontraron resultados</p>
          )
        )}
      </section>
    </Paper>
  );
};

export default NavBar;
